<template>
  <div class="container widget-info">
    <div class="left-wrapper">
      <el-form
        :model="form"
        label-width="120px"
        class="widget-form"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          :label="$t('management.widgetInfo.type_label')"
          prop="type"
        >
          <el-select
            v-model="form.type"
            :placeholder="$t('management.widgetInfo.type_placeholder')"
            @change="handleTypeChange"
          >
            <el-option
              v-for="(type, index) in widgetsType"
              :key="index"
              :value="type.value"
              :label="$t(type.label)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.component_label')"
          prop="componentId"
        >
          <el-select
            v-model="form.componentId"
            filterable
            :placeholder="$t('management.widgetInfo.component_placeholder')"
          >
            <el-option
              v-for="serviceType in serviceTypes"
              :value="serviceType.componentId"
              :label="serviceType.serviceDisplayName"
              :key="serviceType.componentId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.subtype_label')"
          prop="subType"
        >
          <el-select
            v-model="form.subType"
            :placeholder="$t('management.widgetInfo.subtype_placeholder')"
            :disabled="form.type !== 'chart' && form.type !== 'navigation'"
          >
            <template v-if="form.type === 'chart'">
              <el-option
                value="echarts-line"
                :label="$t('common.widget_subtype1')"
              ></el-option>
              <el-option
                value="echarts-bar"
                :label="$t('common.widget_subtype2')"
              ></el-option>
              <el-option
                value="echarts-circle"
                :label="$t('common.widget_subtype3')"
              ></el-option>
            </template>
            <template v-if="form.type === 'navigation'">
              <el-option
                value="full"
                :label="$t('common.widget_nav_subtype1')"
              ></el-option>
              <el-option
                value="card"
                :label="$t('common.widget_nav_subtype2')"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.name_label')"
          prop="name"
        >
          <el-input
            v-model="form.name"
            :placeholder="$t('management.widgetInfo.name_placeholder')"
            :maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.show_title_label')"
          prop="showTitleBar"
        >
          <el-switch
            v-model="form.showTitleBar"
            :active-text="$t('common.active_text')"
            :inactive-text="$t('common.inactive_text')"
            :disabled="form.type === 'navigation'"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.title_label')"
          prop="title"
        >
          <el-input
            v-model="form.title"
            :disabled="!form.showTitleBar"
            :placeholder="$t('management.widgetInfo.title_placeholder')"
            :maxlength="32"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.title_style_label')"
          prop="titleBarStyle"
        >
          <el-input
            v-model="form.titleBarStyle"
            :disabled="!form.showTitleBar"
            :placeholder="$t('management.widgetInfo.title_style_placeholder')"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.border_style_label')"
          prop="borderStyle"
        >
          <el-input
            v-model="form.borderStyle"
            :placeholder="$t('management.widgetInfo.border_style_placeholder')"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.margin_style_label')"
          prop="marginStyle"
        >
          <el-input
            v-model="form.marginStyle"
            :placeholder="$t('management.widgetInfo.margin_style_placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.url_label')"
          prop="url"
          :rules="[{
            required: form.type !== 'navigation',
            message: $t('common.require_valid_error'),
            trigger: 'blur'
          },max255ChartRule]"
        >
          <el-input
            v-model="form.url"
            @keyup.native="form.url = form.url.replace(/\s+/g, '')"
            :placeholder="$t('management.widgetInfo.url_placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.size_label')"
          prop="size"
        >
          <div
            class="m-config-size"
            style="margin-right:20px"
          >
            <el-input v-model="form.width"></el-input>
            <span>{{ $t("management.home.width") }}(px)</span>
          </div>
          <div class="m-config-size">
            <el-input v-model="form.height"></el-input>
            <span>{{ $t("management.home.height") }}(px)</span>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.show_more_label')"
          prop="showMore"
        >
          <el-switch
            v-model="form.showMore"
            :active-text="$t('common.active_text')"
            :inactive-text="$t('common.inactive_text')"
            :disabled="!form.showTitleBar"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          v-show="form.showMore"
          :label="$t('management.widgetInfo.more_open_type_label')"
          prop="moreOpenType"
        >
          <el-select
            v-model="form.moreOpenType"
            :disabled="!form.showMore"
            :placeholder="
              $t('management.widgetInfo.more_open_type_placeholder')
            "
          >
            <el-option
              value="dialog"
              :label="$t('management.widgetInfo.more_open_type1')"
            ></el-option>
            <el-option
              value="frame"
              :label="$t('management.widgetInfo.more_open_type2')"
            ></el-option>
            <el-option
              value="newTab"
              :label="$t('management.widgetInfo.more_open_type3')"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="form.showMore"
          :label="$t('management.widgetInfo.more_url_label')"
          prop="moreUrl"
          :rules="{
            required: form.showMore,
            message: $t('common.require_valid_error'),
            trigger: 'blur'
          }"
        >
          <el-input
            v-model="form.moreUrl"
            :disabled="!form.showMore"
            @keyup.native="form.showMore = form.showMore.replace(/\s+/g, '')"
            :placeholder="$t('management.widgetInfo.more_url_placeholder')"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.widgetInfo.label_timed_refresh')"
          prop="refreshPeriod"
          class="u-refresh-period"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('management.widgetInfo.content_timed_refresh')"
            placement="right"
          >
            <el-input
              v-model="form.refreshPeriod"
              :placeholder="
                $t('management.widgetInfo.placeholder_timed_refresh')
              "
            >
            </el-input>
          </el-tooltip>
          <span class="u-sec">{{ $t("management.widgetInfo.second") }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="right-wrapper">
      <div class="preview">
        <widget-item
          model="preview"
          :data="form"
        ></widget-item>
      </div>
    </div>
  </div>
</template>

<script>
import widgetItem from 'components/widget-item/widget-item'
import Api from 'api/api'
import { ErrorHandleMixin } from 'utils/mixin'
import { requireRule, charRule, max32ChartRule, noAllSpace, max255ChartRule } from 'utils/validator'
export default {
  name: 'widget-info',
  props: {
    addFlag: {
      type: Boolean,
      default: true
    },
    widgetType: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      max255ChartRule: max255ChartRule,
      form: {
        type: 'navigation',
        componentId: '',
        title: '',
        titleBarStyle: '',
        borderStyle: '',
        marginStyle: '',
        url: '',
        subType: 'full',
        moreOpenType: 'dialog',
        moreUrl: '',
        height: 100,
        width: 100,
        previewImg: '',
        name: '',
        showTitleBar: false,
        showMore: false,
        refreshPeriod: ''
      },
      rules: {
        type: [requireRule],
        componentId: [requireRule],
        name: [requireRule, charRule, max32ChartRule, noAllSpace],
        title: [charRule, max32ChartRule, noAllSpace],
        moreUrl: [noAllSpace],
        url: [noAllSpace],
        size: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.form.height === '') {
                callback(
                  new Error(this.$t('management.widgetInfo.height_valid_error'))
                )
              }
              if (this.form.width === '') {
                callback(
                  new Error(this.$t('management.widgetInfo.width_valid_error'))
                )
              }
              callback()
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (!/^[1-9]\d*$/.test(this.form.height)) {
                callback(
                  new Error(
                    this.$t('management.widgetInfo.height_valid_error2')
                  )
                )
              }
              if (!/^[1-9]\d*$/.test(this.form.width)) {
                callback(
                  new Error(this.$t('management.widgetInfo.width_valid_error2'))
                )
              }
              if (parseInt(this.form.height) > 500) {
                callback(
                  new Error(
                    this.$t('management.widgetInfo.height_valid_error3')
                  )
                )
              }
              if (parseInt(this.form.width) > 500) {
                callback(
                  new Error(this.$t('management.widgetInfo.width_valid_error3'))
                )
              }
              if (this.form.width < 100) {
                callback(
                  new Error(this.$t('management.widgetInfo.size_valid_error4'))
                )
              }
              if (this.form.height < 100) {
                callback(
                  new Error(this.$t('management.widgetInfo.size_valid_error4'))
                )
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        refreshPeriod: [
          {
            validator: (rule, value, callback) => {
              if (
                !/^[0-9]\d*$/.test(this.form.refreshPeriod) &&
                this.form.refreshPeriod !== '' &&
                this.form.refreshPeriod !== null
              ) {
                callback(new Error(this.$t('common.period_valid')))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      serviceTypes: [],
      widgetsType: [{
        value: 'navigation',
        label: 'common.widget_type2'
      }, {
        value: 'chart',
        label: 'common.widget_type3'
      }, {
        value: 'table',
        label: 'common.widget_type4'
      }, {
        value: 'image',
        label: 'common.widget_type5'
      }, {
        value: 'page',
        label: 'common.widget_type6'
      }]
    }
  },
  watch: {
    'form.type' (value) {
      if (value === 'navigation') {
        this.form.showTitleBar = false
        this.form.subType = 'full'
      } else if (value === 'chart') {
        if (this.form.subType !== 'echarts-line' && this.form.subType !== 'echarts-bar' && this.form.subType !== 'echarts-circle') {
          this.form.subType = 'echarts-line'
        }
      } else {
        this.form.subType = ''
      }
    },
    'form.showTitleBar' (value) {
      if (value === false) {
        this.form.showMore = false
      }
    }
  },
  mounted () {
    if (this.widgetType === 'all' || this.widgetType === 'todo') {
      this.form.type = 'navigation'
    } else {
      this.form.type = this.widgetType
    }
  },
  methods: {
    fillBack (target) {
      let _target = JSON.parse(JSON.stringify(target))
      this.form = {
        ..._target
      }
    },
    getResult () {
      let _res
      this.$refs.form.validate(valid => {
        _res = valid ? JSON.parse(JSON.stringify(this.form)) : false
      })
      delete _res.imageInfo
      return _res
    },
    handleTypeChange (type) {
      if (this.addFlag) {
        if (type === 'chart') {
          this.form.subType = 'echarts-line'
        } else if (type === 'navigation') {
          this.form.subType = 'full'
        } else {
          this.form.subType = ''
        }
      }
      if (this.form.type === 'navigation') {
        this.$refs.form.validateField('url')
      }
    },
    _getServiceType () {
      Api.widget
        .getServiceType()
        .then(res => {
          this.serviceTypes = res.data.list || []
        })
        .catch(this._handleError)
    }
  },
  created () {
    this._getServiceType()
  },
  mixins: [ErrorHandleMixin],
  components: {
    widgetItem
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.widget-info.container {
  width: 100%;
  position: relative;
  font-size: 0;
  box-sizing: border-box;
  padding-top: 18px;
  padding-left: 12px;
  padding-bottom: 10px;
  .left-wrapper {
    width: 358px;
    display: inline-block;
    vertical-align: top;
  }
  .right-wrapper {
    display: inline-block;
    vertical-align: top;
    margin-left: 16px;
  }
  .widget-form {
    .el-form-item {
      margin-bottom: 12px;
    }
    .m-config-size {
      float: left;
      width: calc(~"50% - 10px");
      height: 64px;
      span {
        display: block;
        text-align: center;
        color: #484c6a;
        font-size: 12px;
      }
    }
  }
  .u-refresh-period {
    /deep/ .el-input {
      width: calc(~"100% - 40px");
      float: left;
    }
    .u-sec {
      float: right;
      margin-right: 10px;
    }
  }
}
</style>
